import React, { useState } from "react";
import axios from "axios";
import FileDownload from "js-file-download";
import { IThreat, AddThreat, EditThreat, DeleteThreat } from "./modal";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/*export const fetchThreatSourceList = async (userid :number | 0) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/RiskAssessment/ThreatSource/${userid}/Details`);

    //console.log("fetchThreatSourceList res", res.data);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const addThreatSource = async (payload: any) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/ThreatSource`, payload);
    // console.log("addThreatSource res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const editThreatSource = async (payload: any) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/api/ThreatSource`, payload);
    // console.log("editThreatSource res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const deleteThreatSource = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/ThreatSource/Delete/Policies`,
      payload
    );
    // console.log("deleteThreatSource res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const fetchThreatSourceImportList = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/ThreatSource/Import/Details`);
    // console.log("fetchThreatSourceImportList res", res);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const importThreatSource = async (payload: any) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/ThreatSource/List`, payload);
    // console.log("importThreatSource res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const downloadThreatSource = async (payload: any) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/ThreatSourceGenerate/Document?CreatedBy=${payload.createdBy}&ThreatSourceId=${payload.ThreatSourceID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadThreatSource res", response, payload);
      FileDownload(response.data, `${payload.ThreatSourceName}.docx`);
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const downloadAllThreatSource = async () => {
  try {
    axios({
      url: `${API_BASE_URL}/api/ThreatSourceGenerate/Document?CreatedBy=184`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadAllThreatSource res", response, payload);
      FileDownload(response.data, `ThreatSource.zip`);
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};*/
// src/services/threatService.ts

export const getThreats = async (
  companyProfileID: number
): Promise<IThreat[]> => {
  const response = await axios.get(
    `${API_BASE_URL}/api/RiskAssessment/ThreatSource/${companyProfileID}/Details`
  );
  return response.data.data;
};

export const getIThreatById = async (id: number): Promise<IThreat> => {
  const response = await axios.get<IThreat>(`/IThreats/${id}`);
  return response.data;
};

export const createIThreat = async (AddThreat: AddThreat): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/ThreatSource`,
      AddThreat
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateIThreat = async (EditThreat: EditThreat): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/ThreatSource`,
      EditThreat
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteIThreat = async (
  DeleteThreat: DeleteThreat
): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/ThreatSource/Delete?id=${DeleteThreat.threatID}&updatedby=${DeleteThreat.updatedBy}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
export const deleteMultipleIThreat = async (
  userId: number,
  payload: number[]
): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/ThreatSource/Delete-All?updatedby=${userId}`, payload
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getThreatSourctImportList = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/ThreatSource/Import/Details`
    );
    // console.log("getThreatSourctImportList res", res);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
export const getExistingThreat = async (
  companyProfileID: number,
  threatIds: number[]
) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/ThreatSource/${companyProfileID}/Exist`, threatIds
    );
    // console.log("getThreatSourctImportList res", res);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const createImport = async (payload: any): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/ThreatSource/Import/Create`,
      payload
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
